var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionMasteryLevel4Background = function SvgCollectionMasteryLevel4Background(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258,
    height: 242,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#collection-mastery-level-4-background_svg__a)",
    d: "m157.812 98.92 99.598 99.598-36.376 36.375-88.777-88.776L36.376 242 0 205.624l106.429-106.43V0h51.383z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "collection-mastery-level-4-background_svg__a",
    x1: 133.735,
    x2: 132.235,
    y1: 23,
    y2: 198.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6E8DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FFFA"
  })))));
};
export default SvgCollectionMasteryLevel4Background;